export const Facility = (json: IFacility): IFacilityModel => ({
	id: json.id,
	name: json.name,
	identifier: json.identifier ?? String(json.id),
	isVirtual: json.is_virtual ?? false,
})
